// components
import { Typography } from '@mui/material';
import StepIcon from './components/StepIcon';

// hooks
import { useTranslation } from 'react-i18next';

// types
import type { ProgressStepsProps } from './ProgressSteps.types';

// styles
import {
  StyledStep,
  StyledStepIconBox,
  StyledStepList
} from './ProgressSteps.styles';

/**
 * The steps of a calculation, each with where it stands.
 *
 * Only the steps and their state: the engine reports no durations and no expected end time, so there
 * is nothing to show about how long one takes. The label comes from our own translations by the
 * step's key, and falls back to the engine's Dutch label for a key the engine added later.
 */
const ProgressSteps = ({ steps, message }: ProgressStepsProps) => {
  'use memo';

  const { t } = useTranslation('common', {
    keyPrefix: 'rosterPlan.automaticRostering.chat.progress'
  });

  return (
    <>
      <StyledStepList aria-label={t('title')}>
        {steps.map((step) => {
          const label = t(`steps.${step.key}`, { defaultValue: step.label });

          return (
            <StyledStep
              key={step.key}
              state={step.state}
              aria-label={`${label}: ${t(`state.${step.state}`)}`}
              aria-current={step.state === 'RUNNING' ? 'step' : undefined}
            >
              <StyledStepIconBox aria-hidden>
                <StepIcon state={step.state} />
              </StyledStepIconBox>
              {label}
            </StyledStep>
          );
        })}
      </StyledStepList>
      {message && (
        <Typography variant="caption" color="error">
          {message}
        </Typography>
      )}
    </>
  );
};

export default ProgressSteps;
